import { Link } from 'react-router-dom'
import { cn } from '../../lib/utils'
import type { LucideIcon } from 'lucide-react'
import { ChevronRight } from 'lucide-react'
import { pagePanel } from '../layout/page-styles'

interface LinkStatCardProps {
  to: string
  icon: LucideIcon
  label: string
  value: React.ReactNode
  hint?: React.ReactNode
  className?: string
  iconClassName?: string
  iconBgClassName?: string
}

export function LinkStatCard({
  to,
  icon: Icon,
  label,
  value,
  hint,
  className,
  iconClassName = 'text-primary-600',
  iconBgClassName = 'bg-primary-50 ring-1 ring-primary-100',
}: LinkStatCardProps) {
  return (
    <Link
      to={to}
      className={cn(
        pagePanel,
        'group p-5 flex items-center justify-between gap-4 hover:bg-surface-card-hover transition-colors duration-150',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-300 focus-visible:ring-offset-2',
        className
      )}
    >
      <div className='min-w-0'>
        <div className='text-2xl font-bold text-neutral-900 tracking-tight'>{value}</div>
        <div className='mt-1 text-sm font-medium text-neutral-600'>{label}</div>
        {hint ? <div className='mt-1.5 text-xs text-neutral-500'>{hint}</div> : null}
      </div>
      <div className='flex items-center gap-2 flex-shrink-0'>
        <div
          className={cn(
            'w-12 h-12 rounded-xl flex items-center justify-center',
            iconBgClassName
          )}
        >
          <Icon className={cn('w-6 h-6', iconClassName)} />
        </div>
        <ChevronRight className='w-4 h-4 text-neutral-300 group-hover:text-primary-600 transition-colors' />
      </div>
    </Link>
  )
}
